<form novalidate aria-label="School Welcome">
  <nsc-system-message></nsc-system-message>

  @if (show.isOrderPauseActive) {
    <nsc-card>
      <nsc-card-title>Ordering is Temporarily Paused</nsc-card-title>
      <nsc-card-content>
        <div class="nsc-pause-message" [innerHTML]="content.orderPauseMessage | safeHtml:'html'">
        </div>
      </nsc-card-content>
    </nsc-card>
  }

  @if (!show.isOrderPauseActive) {
    @if (content.welcomeMessage) {
      <nsc-spacer size="md"></nsc-spacer>
    }
    @if (content.welcomeMessage) {
      <nsc-card>
        <nsc-card-title>School Notifications</nsc-card-title>
        <nsc-card-content>
          <div  [ngClass]="{'ql-editor':content.isNewEditor}" class="nsc-welcome-message" [innerHTML]="content.welcomeMessage | safeHtml:'html'">
          </div>
        </nsc-card-content>
      </nsc-card>
    }
    @if (content.welcomeMessage) {
      <nsc-spacer size="md"></nsc-spacer>
    }
    <nsc-card>
      <nsc-card-title>Clearinghouse Notifications</nsc-card-title>
      <nsc-card-content>
        <ul class="nsc-clearinghouse-notif">
          <li><b>Electronic Transcripts -</b> Must be retrieved <b>using a desktop or laptop computer with Adobe Acrobat Reader</b> due to security features applied to the document. Mobile device and tablet access to the Download Center is blocked.</li>
          <li><b>Payment -</b> If a cost is involved, payment will be accepted with any major credit card or debit card. Your credit or debit card is not charged until your school sends your transcript(s). However, if you use a debit card, your bank may put a hold on your funds when we pre-authorize your payment. If you have any questions about a pre-authorization, please contact your bank.</li>
        </ul>
        <div>
          <a id="schoolselect_addprocess"
            [href]="processFlowURL" target="_blank" rel="noopener"
            aria-describedby="processlink_desc">
            Learn How the Process Works
          </a>
          <span id="processlink_desc" class="cdk-visually-hidden" aria-hidden="true">opens in new window</span>
          </div>
        </nsc-card-content>
      </nsc-card>
      <nsc-spacer size="md"></nsc-spacer>
      <nsc-card>
        <nsc-card-title>Terms of Use</nsc-card-title>
        <nsc-card-content>
          <span id="terms_of_use_desc" class="cdk-visually-hidden" aria-hidden="true">opens in new window</span>
          <ul class="nsc-clearinghouse-notif" role="presentation">
            <li role="presentation"><b>Permitted Use of Service -</b> The public ordering site is designed and intended to be used exclusively by students and alumni ordering their own transcripts. Any use of the service outside of this specific purpose is strictly prohibited and constitutes a violation of our <a href="https://www.studentclearinghouse.org/terms-of-use/" target="_blank" rel="noopener" aria-describedby="terms_of_use_desc">Terms of Use</a> which may result in potential legal action.</li>
            <li role="presentation"><b>Your Information -</b> The personal identifiers you provide as part of your order, which may include your social security number and/or student ID, will be transmitted to your institution to locate your education records and create your transcript. By providing such information, you authorize the use and disclosure of the provided personal identifiers for this purpose.</li>
          </ul>
        </nsc-card-content>
      </nsc-card>
      <nsc-spacer size="md"></nsc-spacer>
      <div class="nsc-form-actions">
        <button
          mat-raised-button
          id="ordertranscript_button"
          class="nsc-form-actions__button nsc-btn__right button-big"
          color="primary"
          type="button"
          (click)="continue()"> Order Transcript(s) <mat-icon aria-hidden="true">chevron_right</mat-icon></button>
        </div>
      }

      <nsc-spacer size="md"></nsc-spacer>
      <div class="col-12 d-flex justify-content-center">
        <a id="view_transcript_status"
          href="#"
          aria-describedby="view_transcript_status_desc"
          (click)="$event.preventDefault(); openConfirmationDialog()">
          View Transcript Order Status
        </a>
        <span id="view_transcript_status_desc" class="cdk-visually-hidden">opens a dialog</span>
      </div>
    </form>
